import React, { Component } from "react";
import { Table, Input, Button, Tooltip, Card, Select, Tag, Modal } from "antd";
import { connect } from "react-redux";
import { API_BASE } from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getDateYYYYMM } from "../../utils/dateUtil";
import {
  req_list_pim_overtime_month_settle,
  req_downloadfile_overtime_month_settle,
} from "../../api";
import OvertimeMonthDetialsModal from "./overtime-month-detials-modal";
import OvertimeMonthOffsetModal from "./overtime-month-offset-modal";

class OvertimeMonthNowStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    item: {},
    deviceWidth: window.innerWidth,
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    data: [],
    isShowDetailsModal: false,
    isShowOffsetModal: false,
    searchMonth: getDateYYYYMM(new Date()),
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.api_item_list();
    this.resize();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 數據配置設定 //////////////////////////////////////////////
  formatTime = (timeString) => {
    // 将字符串按逗号分割并转换为数字
    const [daysStr, hoursStr] = timeString.split(",");
    const days = parseInt(daysStr, 10);
    const hours = parseInt(hoursStr, 10);

    let result = [];

    if (days > 0) {
      result.push(`${days}天`);
    }
    if (hours > 0) {
      result.push(`${hours}小時`);
    }

    return result.join("");
  };

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { searchField, searchValue, searchMonth } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_pim_overtime_month_settle(
      userLevel,
      userCode,
      searchField,
      searchValue,
      searchMonth,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_downloadfile_items = async () => {
    const { searchField, searchValue, searchMonth } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    // download file data
    const fileUrl = await req_downloadfile_overtime_month_settle(
      userCode,
      userLevel,
      searchField,
      searchValue,
      searchMonth,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handle_btn_event = (type, item) => {
    //console.log(item);
    switch (type) {
      case "details":
        this.setState({ isShowDetailsModal: true, item });
        break;
      case "offset":
        this.setState({ isShowOffsetModal: true, item });
        break;

      default:
        break;
    }
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "30px",
        align: "center",
        render: (item) => {
          return (
            <div>
              <button
                className="btn btn-outline-dark btn-sm"
                disabled={item.OvertimeMinutesTotal === 0}
                onClick={() => this.handle_btn_event("details", item)}
              >
                <i className="fas fa-th-list"></i> 明細
              </button>
              <button
                className="btn btn-outline-dark btn-sm"
                disabled={item.OvertimeMinutesTotal === 0}
                onClick={() => this.handle_btn_event("offset", item)}
              >
                <i className="fas fa-calendar-minus"></i> 抵銷
              </button>
            </div>
          );
        },
      },
      {
        title: "月份",
        width: "30px",
        align: "center",
        render: (item) => {
          const { OverTimeMonth } = item;
          return <span style={{ fontWeight: 900 }}>{OverTimeMonth}</span>;
        },
      },
      {
        title: "職號",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffCode } = item;
          return <span style={{ fontWeight: 900 }}>{StaffCode}</span>;
        },
      },
      {
        title: "姓名",
        width: "50px",
        align: "center",
        render: (item) => {
          const { StaffName } = item;
          return <span style={{ fontWeight: 900 }}>{StaffName}</span>;
        },
      },
      {
        title: "加班時數",
        width: "50px",
        align: "center",
        render: (item) => {
          const { HoursAndMinutes, OvertimeMinutesTotal } = item;
          return (
            <span style={OvertimeMinutesTotal > 0 ? { color: "red" } : {}}>
              {HoursAndMinutes}
            </span>
          );
        },
      },
      {
        title: "抵扣時數",
        width: "50px",
        align: "center",
        render: (item) => {
          const { OffsetMinutesTotal, OffsetHoursAndMinutes } = item;
          return (
            <span style={OffsetMinutesTotal > 0 ? { color: "blue" } : {}}>
              {OffsetHoursAndMinutes}
            </span>
          );
        },
      },
      {
        title: "身分別",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { Insurance } = item;
          return (
            <>
              <Tag color={Insurance === "公保" ? "purple" : "orange"}>
                {Insurance}
              </Tag>
            </>
          );
        },
      },
      {
        title: "職類",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffWork } = item;
          return (
            <span style={{ fontWeight: 900, fontSize: "0.8em" }}>
              {StaffWork}
            </span>
          );
        },
      },
      {
        title: "部門",
        width: "90px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { UnitName } = item;
          return <span style={{ fontWeight: 900 }}>{UnitName}</span>;
        },
      },
      {
        title: "電話",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { Cellphone } = item;
          return (
            <span style={{ fontWeight: 900, fontSize: "0.8em" }}>
              {Cellphone}
            </span>
          );
        },
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      item,
      data,
      loading,
      searchField,
      searchValue,
      searchMonth,
      isShowDetailsModal,
      isShowOffsetModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="加班年月"
          style={{ width: 100, margin: "0 5px" }}
          value={searchMonth}
          onChange={(event) =>
            this.setState({ searchMonth: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">請選擇</Select.Option>
          <Select.Option value="StaffCode">職號</Select.Option>
          <Select.Option value="StaffName">姓名</Select.Option>
          <Select.Option value="UnitName">部門名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "6px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </Button>
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowDetailsModal}
          width={450}
          onOk={() => {
            this.setState({ isShowDetailsModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowDetailsModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OvertimeMonthDetialsModal data={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowOffsetModal}
          width={500}
          onOk={() => {
            this.setState({ isShowOffsetModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowOffsetModal: false });
            this.handle_data_refresh();
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OvertimeMonthOffsetModal data={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OvertimeMonthNowStaff);
